import { DOD_ID_VALIDATION_MESSAGE, isValidDODID } from '@ths/shared/utils';

import { useAppSelector } from '../store/store';
import { StringValidatorFunction } from '../utilities/validators';

export const useValidDODID = (): StringValidatorFunction => {
  const clientSubgroups = useAppSelector(
    (state) => state.enums.clientSubgroups,
  );

  return (value: string | null) => {
    if (value == null || value === '') {
      return undefined;
    }

    const validSubgroups = clientSubgroups?.map((subgroup) => subgroup.value);
    if (isValidDODID(value, validSubgroups)) {
      return undefined;
    }

    return `${DOD_ID_VALIDATION_MESSAGE}, or a valid client subgroup`;
  };
};
